var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.5 150.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #b09365;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #b09365;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.25,1C34.24,1,1,34.24,1,75.25s33.24,74.25,74.25,74.25,74.25-33.24,74.25-74.25S116.26,1,75.25,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.89,47.3c10.11-2.09,10.28,18.93,2.12,19.74-9.26.92-9.41-18.23-2.12-19.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.19,47.31c11.75-3.48,10.97,22.84.19,19.38-6.63-2.13-5.9-17.69-.19-19.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.27,105.75h-58.04c-1.46,0-2.64-1.18-2.64-2.64s1.18-2.64,2.64-2.64h58.04c1.46,0,2.64,1.18,2.64,2.64s-1.18,2.64-2.64,2.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralEmpty);
export default __webpack_public_path__ + "static/media/NeutralEmpty.53dd586dc37b087d7778722175443453.svg";
export { ForwardRef as ReactComponent };